/**
 * WHICH EXPENSE NEEDS ITS BILL — the server's own rule (`proofRules` in expense-report.module.ts), so a
 * form never offers to save or submit what the server will refuse:
 *
 *   · a travel mode or category that is on the expense policy → as that policy row says
 *     (BIKE/CAR: "Odometer / fuel bill"; TAXI, OTHER…: their own setting);
 *   · anything else the rep paid for (food, hotel, parking…) → always a receipt.
 *
 * `rates` is `GET /expense-policy` → `travelRates`. Before it has loaded, the answer is the server's
 * default (required), so a save is never offered on a guess that the bill is optional.
 */
export interface ProofRateLike {
  code?: string | null;
  proofRequired?: boolean | null;
  proofLabel?: string | null;
}

export function proofRule(codeOrCategory: string | null | undefined, rates: ProofRateLike[] | null | undefined): { required: boolean; label: string } {
  const code = String(codeOrCategory ?? '').toUpperCase();
  const r = (rates ?? []).find((x) => String(x.code ?? '').toUpperCase() === code);
  if (r) return { required: !!r.proofRequired, label: String(r.proofLabel ?? 'Proof') };
  return { required: true, label: 'Receipt' };
}
